import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material'
import React from 'react'
import { CustomerDto } from '../../../interactors/gen/backendClient'
import { useFormExtended } from '../../../utils/hooks/useFormExtended'
import { ControlledToggleButton } from '../../common/ControlledToggleButton'
import { MemberCardSaveButton } from '../../Members/MemberCardSaveButton'

const sx = { marginTop: 2 }

interface AssociationPermissionsProps {
  association: CustomerDto
  onSubmit: (data: FormParams) => Promise<void>
}

interface FormParams {
  editorsCanCreateAdoptions: boolean
}

export const AssociationPermissions: React.FC<AssociationPermissionsProps> = ({ association, onSubmit }) => {
  const getDefaultValues = (customer: CustomerDto): FormParams => ({
    editorsCanCreateAdoptions: customer?.editorsCanCreateAdoptions || false,
  })

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useFormExtended(association, getDefaultValues)

  return (
    <Card sx={sx}>
      <CardHeader title={`Gestion des permissions`} />
      <CardContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: { xs: 'stretch', sm: 'center' },
              gap: 2,
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Typography sx={{ fontSize: 12, fontWeight: 800, color: '#7A8197' }}>
                Autoriser les éditeurs à créer des procédures d&#39;adoption
              </Typography>
              <Typography sx={{ fontSize: 13, color: '#1F3764', opacity: 0.9 }}>
                Contrôle l&#39;accès à la création des nouvelles adoptions pour les comptes éditeurs.
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 1.25,
                flexWrap: 'wrap',
              }}
            >
              <ControlledToggleButton<FormParams>
                control={control}
                fieldName="editorsCanCreateAdoptions"
                firstOptionLabel="Oui"
                secondOptionLabel="Non"
                firstOptionValue={true}
                secondOptionValue={false}
                error={errors.editorsCanCreateAdoptions}
                requiredRule={undefined}
                sx={{
                  width: 'fit-content',
                  '& .MuiToggleButtonGroup-root': {
                    borderRadius: '999px',
                    overflow: 'hidden',
                    border: '1px solid #D8E1EE',
                    backgroundColor: '#F7FAFD',
                  },
                  '& .MuiToggleButton-root': {
                    px: 2.25,
                    height: '40px',
                    border: 'none',
                    textTransform: 'none',
                    fontSize: 14,
                    fontWeight: 700,
                    color: '#5F6B86',
                    backgroundColor: 'transparent',
                  },
                  '& .MuiToggleButton-root.Mui-selected': {
                    color: '#1F3764',
                    backgroundColor: '#E7F0FA',
                  },
                  '& .MuiToggleButton-root.Mui-selected:hover': {
                    backgroundColor: '#E7F0FA',
                  },
                  '& .MuiToggleButton-root:not(.Mui-selected):hover': {
                    backgroundColor: 'rgba(105, 141, 172, 0.08)',
                  },
                }}
              />
              <MemberCardSaveButton isOwnAccount={false} />
            </Box>
          </Box>
        </form>
      </CardContent>
    </Card>
  )
}
